module.exports = __webpack_public_path__ + "assets/img/duoyang_5.8df1479f.png";